/* tslint:disable */
/* eslint-disable */
/**
 * Export API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const BoltDiameter = {
    None: 'none',
    M12: 'm12',
    M16: 'm16',
    M20: 'm20',
    M24: 'm24',
    M30: 'm30',
    M36: 'm36',
    M42: 'm42',
    M48: 'm48',
    M56: 'm56',
    M64: 'm64',
    M72: 'm72',
    M14: 'm14',
    M18: 'm18',
    M22: 'm22',
    M27: 'm27',
    M33: 'm33',
    M39: 'm39',
    M45: 'm45',
    M52: 'm52',
    M60: 'm60',
    M80: 'm80',
    M90: 'm90',
    M100: 'm100'
} as const;

export type BoltDiameter = typeof BoltDiameter[keyof typeof BoltDiameter];


/**
 * 
 * @export
 * @enum {string}
 */

export const BoltType = {
    None: 'none',
    Hv: 'hv',
    IsO4014: 'isO4014',
    ThreadRod: 'threadRod'
} as const;

export type BoltType = typeof BoltType[keyof typeof BoltType];


/**
 * 
 * @export
 * @enum {string}
 */

export const FileType = {
    Dat: 'dat',
    Csv: 'csv'
} as const;

export type FileType = typeof FileType[keyof typeof FileType];


/**
 * 
 * @export
 * @enum {string}
 */

export const Material = {
    None: 'none',
    Gr88: 'gr8_8',
    Gr109: 'gr10_9',
    Gr129: 'gr12_9'
} as const;

export type Material = typeof Material[keyof typeof Material];



/**
 * FileExportApi - axios parameter creator
 * @export
 */
export const FileExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: `hardware:read`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {string} [fileName] 
         * @param {string} [separator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBolt: async (boltId: string, tenantId: string, fileName?: string, separator?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('exportBolt', 'boltId', boltId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('exportBolt', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/export/v1/export/bolt/{boltId}`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (separator !== undefined) {
                localVarQueryParameter['separator'] = separator;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:read`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {string} [fileName] 
         * @param {string} [separator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBoltConnection: async (boltConnectionId: string, tenantId: string, fileName?: string, separator?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltConnectionId' is not null or undefined
            assertParamExists('exportBoltConnection', 'boltConnectionId', boltConnectionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('exportBoltConnection', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/export/v1/export/bolt-connection/{boltConnectionId}`
                .replace(`{${"boltConnectionId"}}`, encodeURIComponent(String(boltConnectionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (separator !== undefined) {
                localVarQueryParameter['separator'] = separator;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} tenantId 
         * @param {string} [fileName] 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {number} [nominalLengthStart] 
         * @param {number} [nominalLengthEnd] 
         * @param {BoltDiameter} [boltDiameter] 
         * @param {Material} [material] 
         * @param {BoltType} [boltType] 
         * @param {string} [separator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportManufactured: async (tenantId: string, fileName?: string, sortBy?: string, ascending?: boolean, createdAtStart?: string, createdAtEnd?: string, nominalLengthStart?: number, nominalLengthEnd?: number, boltDiameter?: BoltDiameter, material?: Material, boltType?: BoltType, separator?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('exportManufactured', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/export/v1/export/manufactured/bolt`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['ascending'] = ascending;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['createdAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['createdAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (nominalLengthStart !== undefined) {
                localVarQueryParameter['nominalLengthStart'] = nominalLengthStart;
            }

            if (nominalLengthEnd !== undefined) {
                localVarQueryParameter['nominalLengthEnd'] = nominalLengthEnd;
            }

            if (boltDiameter !== undefined) {
                localVarQueryParameter['boltDiameter'] = boltDiameter;
            }

            if (material !== undefined) {
                localVarQueryParameter['material'] = material;
            }

            if (boltType !== undefined) {
                localVarQueryParameter['boltType'] = boltType;
            }

            if (separator !== undefined) {
                localVarQueryParameter['separator'] = separator;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} boltId 
         * @param {string} measurementId 
         * @param {string} tenantId 
         * @param {FileType} [fileType] 
         * @param {string} [fileName] 
         * @param {string} [separator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMeasurement: async (boltId: string, measurementId: string, tenantId: string, fileType?: FileType, fileName?: string, separator?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('exportMeasurement', 'boltId', boltId)
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('exportMeasurement', 'measurementId', measurementId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('exportMeasurement', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/export/v1/export/bolt/{boltId}/measurement/{measurementId}`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"measurementId"}}`, encodeURIComponent(String(measurementId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileType !== undefined) {
                localVarQueryParameter['fileType'] = fileType;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (separator !== undefined) {
                localVarQueryParameter['separator'] = separator;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `structure:read`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {string} [fileName] 
         * @param {string} [separator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProject: async (projectId: string, tenantId: string, fileName?: string, separator?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('exportProject', 'projectId', projectId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('exportProject', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/export/v1/export/project/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (separator !== undefined) {
                localVarQueryParameter['separator'] = separator;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileExportApi - functional programming interface
 * @export
 */
export const FileExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileExportApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: `hardware:read`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {string} [fileName] 
         * @param {string} [separator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportBolt(boltId: string, tenantId: string, fileName?: string, separator?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportBolt(boltId, tenantId, fileName, separator, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileExportApi.exportBolt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:read`
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {string} [fileName] 
         * @param {string} [separator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportBoltConnection(boltConnectionId: string, tenantId: string, fileName?: string, separator?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportBoltConnection(boltConnectionId, tenantId, fileName, separator, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileExportApi.exportBoltConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} tenantId 
         * @param {string} [fileName] 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {number} [nominalLengthStart] 
         * @param {number} [nominalLengthEnd] 
         * @param {BoltDiameter} [boltDiameter] 
         * @param {Material} [material] 
         * @param {BoltType} [boltType] 
         * @param {string} [separator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportManufactured(tenantId: string, fileName?: string, sortBy?: string, ascending?: boolean, createdAtStart?: string, createdAtEnd?: string, nominalLengthStart?: number, nominalLengthEnd?: number, boltDiameter?: BoltDiameter, material?: Material, boltType?: BoltType, separator?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportManufactured(tenantId, fileName, sortBy, ascending, createdAtStart, createdAtEnd, nominalLengthStart, nominalLengthEnd, boltDiameter, material, boltType, separator, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileExportApi.exportManufactured']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} boltId 
         * @param {string} measurementId 
         * @param {string} tenantId 
         * @param {FileType} [fileType] 
         * @param {string} [fileName] 
         * @param {string} [separator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportMeasurement(boltId: string, measurementId: string, tenantId: string, fileType?: FileType, fileName?: string, separator?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportMeasurement(boltId, measurementId, tenantId, fileType, fileName, separator, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileExportApi.exportMeasurement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `structure:read`
         * @param {string} projectId 
         * @param {string} tenantId 
         * @param {string} [fileName] 
         * @param {string} [separator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportProject(projectId: string, tenantId: string, fileName?: string, separator?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportProject(projectId, tenantId, fileName, separator, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileExportApi.exportProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileExportApi - factory interface
 * @export
 */
export const FileExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileExportApiFp(configuration)
    return {
        /**
         * Required permissions: `hardware:read`
         * @param {FileExportApiExportBoltRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBolt(requestParameters: FileExportApiExportBoltRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportBolt(requestParameters.boltId, requestParameters.tenantId, requestParameters.fileName, requestParameters.separator, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:read`
         * @param {FileExportApiExportBoltConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBoltConnection(requestParameters: FileExportApiExportBoltConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportBoltConnection(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.fileName, requestParameters.separator, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:read`
         * @param {FileExportApiExportManufacturedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportManufactured(requestParameters: FileExportApiExportManufacturedRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportManufactured(requestParameters.tenantId, requestParameters.fileName, requestParameters.sortBy, requestParameters.ascending, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.nominalLengthStart, requestParameters.nominalLengthEnd, requestParameters.boltDiameter, requestParameters.material, requestParameters.boltType, requestParameters.separator, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:read`
         * @param {FileExportApiExportMeasurementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMeasurement(requestParameters: FileExportApiExportMeasurementRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportMeasurement(requestParameters.boltId, requestParameters.measurementId, requestParameters.tenantId, requestParameters.fileType, requestParameters.fileName, requestParameters.separator, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `structure:read`
         * @param {FileExportApiExportProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProject(requestParameters: FileExportApiExportProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportProject(requestParameters.projectId, requestParameters.tenantId, requestParameters.fileName, requestParameters.separator, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for exportBolt operation in FileExportApi.
 * @export
 * @interface FileExportApiExportBoltRequest
 */
export interface FileExportApiExportBoltRequest {
    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportBolt
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportBolt
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportBolt
     */
    readonly fileName?: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportBolt
     */
    readonly separator?: string
}

/**
 * Request parameters for exportBoltConnection operation in FileExportApi.
 * @export
 * @interface FileExportApiExportBoltConnectionRequest
 */
export interface FileExportApiExportBoltConnectionRequest {
    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportBoltConnection
     */
    readonly boltConnectionId: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportBoltConnection
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportBoltConnection
     */
    readonly fileName?: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportBoltConnection
     */
    readonly separator?: string
}

/**
 * Request parameters for exportManufactured operation in FileExportApi.
 * @export
 * @interface FileExportApiExportManufacturedRequest
 */
export interface FileExportApiExportManufacturedRequest {
    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportManufactured
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportManufactured
     */
    readonly fileName?: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportManufactured
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof FileExportApiExportManufactured
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportManufactured
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportManufactured
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {number}
     * @memberof FileExportApiExportManufactured
     */
    readonly nominalLengthStart?: number

    /**
     * 
     * @type {number}
     * @memberof FileExportApiExportManufactured
     */
    readonly nominalLengthEnd?: number

    /**
     * 
     * @type {BoltDiameter}
     * @memberof FileExportApiExportManufactured
     */
    readonly boltDiameter?: BoltDiameter

    /**
     * 
     * @type {Material}
     * @memberof FileExportApiExportManufactured
     */
    readonly material?: Material

    /**
     * 
     * @type {BoltType}
     * @memberof FileExportApiExportManufactured
     */
    readonly boltType?: BoltType

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportManufactured
     */
    readonly separator?: string
}

/**
 * Request parameters for exportMeasurement operation in FileExportApi.
 * @export
 * @interface FileExportApiExportMeasurementRequest
 */
export interface FileExportApiExportMeasurementRequest {
    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportMeasurement
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportMeasurement
     */
    readonly measurementId: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportMeasurement
     */
    readonly tenantId: string

    /**
     * 
     * @type {FileType}
     * @memberof FileExportApiExportMeasurement
     */
    readonly fileType?: FileType

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportMeasurement
     */
    readonly fileName?: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportMeasurement
     */
    readonly separator?: string
}

/**
 * Request parameters for exportProject operation in FileExportApi.
 * @export
 * @interface FileExportApiExportProjectRequest
 */
export interface FileExportApiExportProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportProject
     */
    readonly projectId: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportProject
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportProject
     */
    readonly fileName?: string

    /**
     * 
     * @type {string}
     * @memberof FileExportApiExportProject
     */
    readonly separator?: string
}

/**
 * FileExportApi - object-oriented interface
 * @export
 * @class FileExportApi
 * @extends {BaseAPI}
 */
export class FileExportApi extends BaseAPI {
    /**
     * Required permissions: `hardware:read`
     * @param {FileExportApiExportBoltRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileExportApi
     */
    public exportBolt(requestParameters: FileExportApiExportBoltRequest, options?: RawAxiosRequestConfig) {
        return FileExportApiFp(this.configuration).exportBolt(requestParameters.boltId, requestParameters.tenantId, requestParameters.fileName, requestParameters.separator, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:read`
     * @param {FileExportApiExportBoltConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileExportApi
     */
    public exportBoltConnection(requestParameters: FileExportApiExportBoltConnectionRequest, options?: RawAxiosRequestConfig) {
        return FileExportApiFp(this.configuration).exportBoltConnection(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.fileName, requestParameters.separator, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:read`
     * @param {FileExportApiExportManufacturedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileExportApi
     */
    public exportManufactured(requestParameters: FileExportApiExportManufacturedRequest, options?: RawAxiosRequestConfig) {
        return FileExportApiFp(this.configuration).exportManufactured(requestParameters.tenantId, requestParameters.fileName, requestParameters.sortBy, requestParameters.ascending, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.nominalLengthStart, requestParameters.nominalLengthEnd, requestParameters.boltDiameter, requestParameters.material, requestParameters.boltType, requestParameters.separator, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:read`
     * @param {FileExportApiExportMeasurementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileExportApi
     */
    public exportMeasurement(requestParameters: FileExportApiExportMeasurementRequest, options?: RawAxiosRequestConfig) {
        return FileExportApiFp(this.configuration).exportMeasurement(requestParameters.boltId, requestParameters.measurementId, requestParameters.tenantId, requestParameters.fileType, requestParameters.fileName, requestParameters.separator, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `structure:read`
     * @param {FileExportApiExportProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileExportApi
     */
    public exportProject(requestParameters: FileExportApiExportProjectRequest, options?: RawAxiosRequestConfig) {
        return FileExportApiFp(this.configuration).exportProject(requestParameters.projectId, requestParameters.tenantId, requestParameters.fileName, requestParameters.separator, options).then((request) => request(this.axios, this.basePath));
    }
}



